export default __webpack_public_path__ + "static/media/logo-white.3ccdcb04.svg";